var exports = {
  "w": "footnotesList__l_Gvza",
  "x": "footnotesItem__7ufNtt",
};

module.exports = exports;
